import { Price } from "../types/prices";
import { PriceDisplayGroup } from "../types/product";
import { UnitPrice } from "../types/tieredPrices";

function calculateTotalSavings(unitListPrice: Price, unitDiscountedPrice: Price, unitListPriceForMoq: Price, currency: string, isVatInclusive: boolean): number {
  const unitPriceMoq = isVatInclusive ? unitListPriceForMoq.taxed : unitListPriceForMoq.untaxed;
  const { unitDiscountedPrice: discountedPrice } = getUnitPriceDetails(unitListPrice, unitDiscountedPrice, isVatInclusive, currency);
  const savings = getPercentage(discountedPrice, unitPriceMoq);
  return savings;
}

function isDiscounted(totalListPrice: Price, totalDiscountedPrice: Price, isVatInclusive: boolean) {
  const listPrice = isVatInclusive ? totalListPrice.taxed : totalListPrice.untaxed;
  const discountedPrice = isVatInclusive ? totalDiscountedPrice.taxed : totalDiscountedPrice.untaxed;
  return listPrice !== discountedPrice;
}

function getPercentage(value: number, referenceValue: number) {
  return Math.round((1 - value / referenceValue) * 100);
}

function getUnitPriceDetails(unitListPrice: Price, unitDiscountedPrice: Price, isVatInclusive: boolean, currency: string): UnitPrice {
  if (!unitListPrice || !unitDiscountedPrice || !currency) {
    throw new Error("One or more required parameters are null or undefined: unitListPrice, unitDiscountedPrice, or currency.");
  }
  return {
    unitPrice: isVatInclusive ? unitListPrice.taxed : unitListPrice.untaxed,
    unitDiscountedPrice: isVatInclusive ? unitDiscountedPrice.taxed : unitDiscountedPrice.untaxed,
    currency: currency,
  };
}

function isRangePriceDisplayGroup(priceDisplayGroup: string | undefined): boolean {
  return priceDisplayGroup?.startsWith(PriceDisplayGroup.RANGED) || false;
}

function isEachPriceDisplayGroup(priceDisplayGroup: string): boolean {
  return priceDisplayGroup === PriceDisplayGroup.EACH;
}

function isEmptyPrice(price?: Price): boolean {
  return !price || (price.taxed === 0 && price.untaxed === 0);
}

export { calculateTotalSavings, isDiscounted, isEachPriceDisplayGroup, isEmptyPrice, isRangePriceDisplayGroup };
